import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiHttpService, ApiService } from '@capturum/api';
import { Region } from '@features/regions/models/region.model';
import { UserModel } from '@features/user/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class LogoService extends ApiService<Region> {
  public currentUserRoleChanged: BehaviorSubject<UserModel> = new BehaviorSubject(null);

  constructor(apiHttp: ApiHttpService) {
    super(apiHttp);
    }

  public getMenuLogo(regionId: string): Observable<{ url: string }> {
    return this.apiHttp.get(`/region/${regionId}/logo`);
  }
}
